module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "frame-17-1.cda09989.svg";